// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PcwHi","title":"styles_title__2XYZQ"};